import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      const { language = 'he' } = this.props;
      const isHe = language === 'he';

      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '40vh',
          gap: '16px',
          padding: '32px',
          textAlign: 'center',
        }}>
          <span style={{ fontSize: '2.5rem' }}>&#x26A0;&#xFE0F;</span>
          <h2 style={{ fontFamily: 'var(--font-serif)', fontWeight: 500, margin: 0 }}>
            {isHe ? 'משהו השתבש' : 'Something went wrong'}
          </h2>
          <p style={{ color: 'var(--spa-text-secondary)', maxWidth: 400 }}>
            {isHe
              ? 'אירעה שגיאה בלתי צפויה. נסו לרענן את העמוד.'
              : 'An unexpected error occurred. Try refreshing the page.'}
          </p>
          <button
            onClick={this.handleReset}
            style={{
              padding: '10px 24px',
              borderRadius: 'var(--radius-pill, 50px)',
              border: '1px solid var(--spa-sage, #9caf88)',
              background: 'transparent',
              color: 'var(--spa-sage-dark, #7a8f68)',
              cursor: 'pointer',
              fontFamily: 'var(--font-sans)',
              fontWeight: 600,
            }}
          >
            {isHe ? 'נסה שוב' : 'Try Again'}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
